import "intersection-observer";
import * as React from "react";
import { InView } from "react-intersection-observer";
import { IOWidget, Updater, fromJSX } from "widgets-for-react";
import { blockInviewHandler } from "../../../drupal/rendering/inview_utils.mod";
import { CMSState } from '../../../publicSite/drupalPage/state'
import { getClassName } from "../utils.gen";

export type TextBlockNestedProps = {
  index: number
  text: string
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export type TextBlockNestedStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  text_classname: string
}>

export function TextBlockNested(
  props: TextBlockNestedProps,
  options?: { style?: TextBlockNestedStyle; key?: string }
): IOWidget<CMSState, Updater<CMSState>> {
  return (s: CMSState) =>
    fromJSX(
      onDone => (
        <InView
          as="div"
          onChange={(inView) => blockInviewHandler('text', inView, `io-${options && options.key ? options.key : props.index}`, getClassName(options, "inview_classname", "inview"))}
          triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
          threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
          id={`io-${options && options.key ? options.key : props.index}`}
          className={getClassName(options, "block_classname", "")}
          key={options && options.key ? options.key : `block-${props.index}`}
        >
          <div className={getClassName(options, "inner_classname", "py-5")}>
            {props.text && (
              <div className={getClassName(options, "content_classname", "")}>
                <div className={getClassName(options, "text_classname", "")} dangerouslySetInnerHTML={{ __html: props.text }} />
              </div>
            )}
          </div>
        </InView>
    )
  )
}
